import styled from 'styled-components';

export const Styles = styled.div`
  padding: 18px;
  width: calc(100% - 24px);
  min-height: calc(100vh - 140px);
  background: linear-gradient(180deg, #27293d 0%, #1f2233 100%);
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  .customer-manager-layout {
    display: flex;
    align-items: stretch;
    gap: 22px;
    min-height: calc(100vh - 210px);
  }

  .customer-list-panel {
    width: 25%;
    min-width: 320px;
    max-width: 420px;
    background: rgba(15, 23, 42, 0.45);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 14px;
    padding: 16px;
    display: flex;
    flex-direction: column;
  }

  .customer-toggle-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 14px;
  }

  .toggle-button {
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.78);
    border-radius: 10px;
    padding: 11px 12px;
    font-size: 0.92rem;
    font-weight: 700;
    transition: all 0.2s ease;
  }

  .toggle-button.active {
    background: #f7941d;
    color: #1d253b;
    border-color: #f7941d;
    box-shadow: 0 10px 24px rgba(247, 148, 29, 0.25);
  }

  .filters-panel {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .customer-search-input {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(9, 13, 25, 0.6);
    color: #ffffff;
    border-radius: 10px;
    padding: 11px 13px;
    font-size: 0.92rem;
    outline: none;
  }

  .customer-search-input::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }

  .location-filter-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .customer-results-meta {
    color: rgba(255, 255, 255, 0.58);
    font-size: 0.82rem;
    margin: 14px 2px 10px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .customer-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
    padding-right: 4px;
  }

  .customer-list-item {
    width: 100%;
    padding: 9px 11px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.06);
    text-align: left;
    appearance: none;
    cursor: pointer;
    transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
  }

  .customer-list-item:hover {
    transform: translateY(-1px);
    background: rgba(247, 148, 29, 0.1);
    border-color: rgba(247, 148, 29, 0.38);
  }

  .customer-list-item.selected {
    background: rgba(247, 148, 29, 0.14);
    border-color: rgba(247, 148, 29, 0.45);
    box-shadow: 0 10px 24px rgba(247, 148, 29, 0.12);
  }

  .customer-list-item__body.compact {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .customer-list-item__header {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 1px;
  }

  .customer-list-item__header h5 {
    margin: 0;
    color: #ffffff;
    font-size: 0.92rem;
    line-height: 1.15;
  }

  .customer-list-item p {
    margin: 0;
    color: rgba(255, 255, 255, 0.68);
    font-size: 0.78rem;
    line-height: 1.2;
    word-break: break-word;
  }

  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    flex: 0 0 auto;
  }

  .status-dot.enabled {
    background: #2bbbae;
    box-shadow: 0 0 0 4px rgba(43, 187, 174, 0.15);
  }

  .status-dot.disabled {
    background: #be1e2d;
    box-shadow: 0 0 0 4px rgba(190, 30, 45, 0.14);
  }

  .customer-empty-state {
    border: 1px dashed rgba(255, 255, 255, 0.12);
    border-radius: 12px;
    padding: 18px 14px;
    text-align: center;
    color: rgba(255, 255, 255, 0.55);
    background: rgba(255, 255, 255, 0.02);
  }

  .customer-placeholder-panel {
    flex: 1;
    border-radius: 16px;
    background:
      radial-gradient(circle at top right, rgba(247, 148, 29, 0.16), transparent 28%),
      radial-gradient(circle at bottom left, rgba(43, 187, 174, 0.12), transparent 24%),
      rgba(11, 16, 29, 0.42);
    border: 1px solid rgba(255, 255, 255, 0.06);
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    padding: 24px;
    overflow: hidden;
  }

  .customer-placeholder-panel__content {
    max-width: 420px;
    text-align: center;
    margin: auto;
  }

  .customer-placeholder-panel__content h4 {
    color: #ffffff;
    font-size: 1.6rem;
    margin-bottom: 12px;
  }

  .customer-placeholder-panel__content p {
    color: rgba(255, 255, 255, 0.66);
    margin: 0;
    line-height: 1.6;
  }

  .detail-error-message {
    margin-top: 14px !important;
    color: #ff8f8f !important;
  }

  .store-detail-panel {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 18px;
    overflow-y: auto;
    padding-right: 2px;
  }

  .store-detail-card {
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 16px;
    padding: 18px;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.16);
  }

  .store-detail-card.hero {
    background:
      linear-gradient(135deg, rgba(247, 148, 29, 0.12), transparent 38%),
      rgba(255, 255, 255, 0.05);
  }

  .store-detail-card.users {
    padding-bottom: 10px;
  }

  .store-detail-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;
  }

  .store-detail-card__header.section {
    align-items: center;
  }

  .store-detail-card__header h3,
  .store-detail-card__header h4 {
    margin: 0;
    color: #ffffff;
  }

  .store-detail-card__header p {
    margin: 4px 0 0;
    color: rgba(255, 255, 255, 0.62);
  }

  .store-detail-card__controls {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .icon-edit-button,
  .table-icon-button {
    width: 36px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: rgba(255, 255, 255, 0.05);
    color: #ffffff;
    transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
  }

  .icon-edit-button:hover,
  .table-icon-button:hover,
  .icon-edit-button.active {
    background: rgba(247, 148, 29, 0.14);
    border-color: rgba(247, 148, 29, 0.45);
    transform: translateY(-1px);
  }

  .detail-inline-notice {
    margin-bottom: 14px;
    color: rgba(255, 255, 255, 0.76);
    font-size: 0.86rem;
  }

  .detail-eyebrow {
    display: inline-block;
    margin-bottom: 8px;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: rgba(255, 255, 255, 0.48);
  }

  .detail-status {
    border-radius: 999px;
    padding: 7px 12px;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.04em;
  }

  .detail-status.enabled {
    background: rgba(43, 187, 174, 0.12);
    color: #70e5d8;
  }

  .detail-status.disabled {
    background: rgba(190, 30, 45, 0.12);
    color: #ff8f9a;
  }

  .detail-status-stack {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }

  .detail-select-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    margin: 0;
  }

  .detail-select-group span {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .detail-select {
    min-width: 150px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(8, 12, 24, 0.7);
    color: #ffffff;
    border-radius: 10px;
    padding: 9px 12px;
    font-size: 0.86rem;
  }

  .store-detail-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 18px;
  }

  .store-detail-grid.compact-info label {
    display: block;
    margin-bottom: 7px;
    font-size: 0.75rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.46);
  }

  .store-detail-grid.compact-info p {
    margin: 0;
    color: #ffffff;
    font-size: 0.95rem;
    line-height: 1.45;
    word-break: break-word;
  }

  .detail-input {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(8, 12, 24, 0.65);
    color: #ffffff;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 0.9rem;
  }

  .detail-input.compact {
    padding: 8px 10px;
    font-size: 0.84rem;
  }

  .detail-action-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 18px;
    flex-wrap: wrap;
  }

  .secondary-detail-button {
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 10px;
    background: transparent;
    color: rgba(255, 255, 255, 0.86);
    padding: 10px 14px;
    font-weight: 700;
  }

  .hours-section-toggle {
    display: block;
    width: 100%;
    text-align: left;
    background: transparent;
    border: 0;
    padding: 0;
    color: inherit;
  }

  .hours-collapsed-summary {
    display: grid;
    gap: 8px;
  }

  .hours-collapsed-summary__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-top: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.78);
    font-size: 0.88rem;
  }

  .hours-collapsed-summary__row strong {
    color: #ffffff;
    font-size: 0.84rem;
  }

  .span-2 {
    grid-column: span 2;
  }

  .save-hours-button {
    border: 0;
    border-radius: 10px;
    background: #f7941d;
    color: #1d253b;
    padding: 10px 14px;
    font-weight: 700;
    min-width: 120px;
  }

  .save-hours-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .hours-notice {
    margin-bottom: 14px;
    color: rgba(255, 255, 255, 0.78);
    font-size: 0.88rem;
  }

  .hours-table {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .hours-table__head,
  .hours-table__row {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 0.9fr;
    gap: 12px;
    align-items: center;
  }

  .hours-table__head {
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .hours-table__row {
    padding: 10px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
  }

  .hours-table__row span {
    color: #ffffff;
    font-size: 0.9rem;
  }

  .hours-table input[type='time'] {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(8, 12, 24, 0.65);
    color: #ffffff;
    border-radius: 10px;
    padding: 9px 10px;
  }

  .hours-checkbox {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
  }

  .detail-count {
    color: rgba(255, 255, 255, 0.58);
    font-size: 0.82rem;
  }

  .users-table-wrapper {
    overflow-x: auto;
  }

  .users-table {
    width: 100%;
    border-collapse: collapse;
  }

  .users-table th,
  .users-table td {
    padding: 12px 10px;
    text-align: left;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.86rem;
    vertical-align: top;
  }

  .users-table th {
    color: rgba(255, 255, 255, 0.48);
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    border-top: 0;
    padding-top: 0;
  }

  .users-empty-state {
    text-align: center !important;
    color: rgba(255, 255, 255, 0.54) !important;
  }

  .table-edit-stack {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .users-table__auth0-id {
    color: rgba(255, 255, 255, 0.48);
    font-size: 0.8rem;
    word-break: break-all;
  }

  .table-action-row {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .table-edit-button {
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 9px;
    background: transparent;
    color: rgba(255, 255, 255, 0.86);
    padding: 7px 10px;
    font-size: 0.78rem;
    font-weight: 700;
  }

  .table-edit-button.primary {
    background: #f7941d;
    border-color: #f7941d;
    color: #1d253b;
  }

  .add-user-button {
    padding: 8px 14px;
  }

  .add-user-modal__body {
    padding: 0;
    background: #1f2233;
  }

  @media (max-width: 1100px) {
    .customer-manager-layout {
      flex-direction: column;
    }

    .customer-list-panel {
      width: 100%;
      max-width: none;
      min-width: 0;
    }

    .customer-placeholder-panel {
      min-height: 220px;
    }

    .store-detail-grid,
    .hours-table__head,
    .hours-table__row {
      grid-template-columns: 1fr;
    }

    .span-2 {
      grid-column: auto;
    }

    .store-detail-card__header,
    .store-detail-card__header.section {
      flex-direction: column;
      align-items: flex-start;
    }

    .detail-action-row,
    .table-action-row,
    .store-detail-card__controls {
      width: 100%;
      justify-content: flex-start;
    }

    .detail-status-stack {
      align-items: flex-start;
    }

    .hours-collapsed-summary__row {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;

export const IndividualsHeader = styled.h4`
  margin-top: 30px;
  font-size: 1rem; /* Slightly larger text */
  background-color: #ffa500; /* Light gray background */
  color: #333; /* Dark text for contrast */
  padding: 5px 20px; /* Add padding for a box effect */
  border-radius: 5px; /* Optional: Rounded corners */
  display: inline-block; /* Keeps the header compact */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional: Subtle shadow */
`;
